export const washingHistory = {
  title: 'Washing History',
  laundrySuccess: 'Create laundry successfully',
  laundryFail: 'Create laundry fail',
}
